require("./ynet_site_redMailComponenta.less")

import { RedMailFileUploadYnet } from "./filesUpload/RedMailFileUploadYnet";
import { RedMailComponentaProps } from "../interfaces/redMailInterfaces";
import { ExtraDetailsYnet } from "./extraDetails/extraDetailsYnet"
import { PopUpYnet } from "./popUp/popUpYnet"
import { TextAreaYnet } from "./textArea/textAreaYnet";

export interface RedMailComponentaYnetProps extends RedMailComponentaProps {
    handleRemoveFile?: (fileKey: string) => void;
}

export class RedMailComponentaYnet extends React.Component<RedMailComponentaYnetProps & {isChecked: boolean}, {}>{

    public render() {
        const { handleChangeText, isTextAreaBlank, countSubmitAttempts, textArea,
                handleSelectedFile, selectedFiles, hashes, invalidFilesName, showFileStatusProgress,
                photographer, sender, mail, phoneNumber, validation, handleChangeExtraData, isAgreementApproved,
                IsPopUp, submitForm, loading, onClose, submitButtonDisabled, isChecked, handleRemoveFile } = this.props;

        const ynetTermsHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html";
        const ynetPolicyHref = "https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html";
        const ynetTermsLink = <a href={ynetTermsHref} className="termsClick">תנאי השימוש</a>
        const ynetPolicyLink = <a href={ynetPolicyHref} className="termsClick">מדיניות הפרטיות</a>

        const textData = {
            headlineText: "המייל האדום",
            textArea: {
                textAreaHeadline: `יש לכם מידע חשוב שטרם נחשף? צילומים מאירוע חדשותי? מצאתם טעות בכתבה?
                ניתן לשתף בווטסאפ, בטלגרם או כאן
                (ולא חייבים להזדהות)`,
                placeholder: "*מה תרצו לשתף?",
            },
            extraDetailsData: {
                title: "פרטים נוספים (אופציונלי)",
                subTitle: "",
                mailPattern: "צריך להיות בתבנית הבאה: ynet@ynet.com "
            },
            terms: <>הריני לאשר שהתוכן שאשלח: מקורי, לא מזויף או מבוים, לא מימנתי את הפקתו, הוא אינו מועתק או נגוע במעשה בלתי חוקי כגון הסגת גבול ופגיעה בפרטיות. התוכן לא הופק, לא נערך ולא עבר כל עיבוד באמצעות בינה מלאכותית (AI), בין באופן מלא ובין באופן חלקי. אני מצהיר כי אני מודע לכך שחל איסור לשלוח תוכן שאינו עומד בכללים אלה. כמו כן, התוכן לא נשלח לשום גורם אחר במקביל והוא מועבר לבעלותכם הבלעדית, ללא עלות וללא מגבלה. פרטיי מהימנים לטובת קרדיט לצד פרסום התוכן, אם תבחרו לפרסמו ובמידה ותידרשו למסור אותם לגורם רשמי. קראתי, הבנתי ומסכים לאמור ב{ynetTermsLink} וב{ynetPolicyLink} ולקבלת דיוורים מאתר ynet.</>
        }

        return (
            <div>
               <div className="RedMailComponenta">
                 <div className="redMailLeftSide">
                        <div className="redMailHeadline">
                            <div className="headlineImage" />
                            <p className="headlineText">המייל האדום</p>
                        </div>
                        
                        <TextAreaYnet textAreaData={textData.textArea} value={textArea} isChecked={isChecked} onChange={handleChangeText} isTextAreaBlank={isTextAreaBlank && countSubmitAttempts > 0} />
                        {(isTextAreaBlank && countSubmitAttempts > 0) && <div className="contentErrorMessage">נראה ששכחת לצרף את תוכן ההודעה</div>}
                                              
                        <RedMailFileUploadYnet
                            handleSelectedFile={handleSelectedFile}
                            selectedFiles={selectedFiles}
                            hashes={hashes}
                            invalidFilesName={invalidFilesName}
                            showFileStatusProgress={showFileStatusProgress}
                            handleRemoveFile={handleRemoveFile}
                        />
                        <div className="upload_text">
                        ניתן להעלות קבצי mov, png, jpeg, jpg, mp4 עד 200MB
                        </div>
                        <ExtraDetailsYnet
                            photographer={photographer}
                            sender={sender}
                            mail={mail}
                            phoneNumber={phoneNumber}
                            onChange={handleChangeExtraData}
                            validation={validation}
                            extraDetailsData={textData.extraDetailsData}
                        />

                        <p className="terms">
                            <input className="checkBox" id="agreementApproved" type="checkbox" checked={isAgreementApproved} onChange={(e) => handleChangeExtraData(e)} />
                            {textData.terms}
                        </p>

                        {(!isAgreementApproved && countSubmitAttempts > 0) && <div className="contentErrorMessage terms-error">יש לאשר את תנאי השימוש</div>}                 
                      
                        <button
                            disabled={submitButtonDisabled}
                            className="submitButton"
                            type="submit"
                            onClick={submitForm}>
                            שליחה
                        </button>
                     {IsPopUp && <PopUpYnet onClose={onClose} loading={loading} />}
                 </div>
                </div>
            </div>
        )

    }
}



